export default __webpack_public_path__ + "static/media/ElephantPage1.231b28dc.txt";